import styled from 'styled-components'

export const RotationPageWrap = styled.div`
    padding: 4px 0 8px;
    overflow: visible;

    .weekly-assignments-header {
        @media (max-width: 930px) {
            flex-direction: column;
            align-items: stretch;
        }
    }

    .ui.form .fields,
    .ui.form .field {
        @media (max-width: 930px) {
            width: 100% !important;
        }
    }
`

export const RotationStepCard = styled.div`
    position: relative;
    z-index: 1;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    margin-bottom: 28px;
    box-shadow:
        0 8px 24px rgba(15, 23, 42, 0.08),
        0 2px 6px rgba(15, 23, 42, 0.04);
    overflow: visible;
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow:
            0 12px 28px rgba(15, 23, 42, 0.1),
            0 4px 10px rgba(15, 23, 42, 0.06);
    }

    &:has(.ui.dropdown.active),
    &:has(.ui.dropdown.visible),
    &:has(.clndr-floating) {
        z-index: 300;
    }
`

export const RotationStepHeader = styled.div`
    padding: 16px 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border-bottom: 1px solid #e2e8f0;
    border-radius: 12px 12px 0 0;

    @media (max-width: 930px) {
        padding: 14px 16px;
    }
`

export const RotationStepTitle = styled.h5`
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
    letter-spacing: 0.01em;
`

export const RotationStepSubtitle = styled.p`
    margin: 6px 0 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 400;
    line-height: 1.4;
`

export const RotationStepBody = styled.div`
    padding: 24px;
    overflow: visible;

    @media (max-width: 930px) {
        padding: 16px;
    }

    .ui.dropdown.active,
    .ui.dropdown.visible {
        z-index: 2000;
    }

    .ui.dropdown .menu {
        z-index: 2001 !important;
    }

    .field {
        position: relative;
        z-index: auto;
    }

    .react-datepicker-popper {
        z-index: 2001 !important;
    }

    .field.clndr-floating {
        z-index: 2000;
    }
`

export const RotationFooterCard = styled(RotationStepCard)`
    margin-bottom: 32px;
`
